export default __webpack_public_path__ + "static/media/keyvisual-lengerich.38214e74.jpg";